export default "__VITE_ASSET__CLGfP4ZK__"